import { Routes } from '@angular/router';
import { authGuard, roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const maintenanceContractsRoutes: Routes = [
  {
    path: 'maintenance-contracts',
    title: 'Wartungsverträge Übersicht',
    loadComponent: () =>
      import('./maintenance-contracts-list/maintenance-contracts-list').then(
        m => m.MaintenanceContractsListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'maintenance-contracts/new',
    title: 'Neuer Wartungsvertrag',
    loadComponent: () =>
      import('./maintenance-contract-form/maintenance-contract-form').then(
        m => m.MaintenanceContractFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
  {
    path: 'maintenance-contracts/:id/edit',
    title: 'Wartungsvertrag bearbeiten',
    loadComponent: () =>
      import('./maintenance-contract-form/maintenance-contract-form').then(
        m => m.MaintenanceContractFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.MASTERDATA_WRITE] },
  },
];
